exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-settings .MuiDialogContent-root {\n  width: 30rem;\n  height: 20rem;\n  max-height: 30rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1.2rem; }\n\n.chart-settings .type-select {\n  text-transform: capitalize; }\n\n.chart-settings .field-selector, .chart-settings .bell-curve {\n  margin-top: 1.5rem; }\n\n.chart-settings .field-selector.multi .MuiSelect-root {\n  max-width: 12rem;\n  padding-right: 2rem; }\n\n.chart-settings .field-selector .MuiInputLabel-shrink {\n  top: -1rem;\n  width: 12rem; }\n", ""]);

// exports
